import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import persistConfig from './persistConfig';

export default function configureStore(initialState = {}, callback) {
  // Create the store with two middlewares
  // 1. thunk
  // 2. routerMiddleware: Syncs the location/URL path to the state
  const middlewares = [
    thunk,
    routerMiddleware(browserHistory),
  ];

  /* istanbul ignore if */
  if (process.env.__DEVCLIENT__) {
    middlewares.push(createLogger());
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer));
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );
  store.asyncReducers = {};

  store.injectReducer = (key, reducer) => {
    if (Object.keys(store.asyncReducers).includes(key)) {
      return;
    }
    store.asyncReducers[key] = reducer;

    const combinedReducers = combineReducers({
      ...rootReducer,
      ...store.asyncReducers,
    });

    const persistedCombinedReducer = persistReducer(persistConfig, combinedReducers);
    store.replaceReducer(persistedCombinedReducer);
  };

  persistStore(store, null, () => callback(store));
}
